import { render, staticRenderFns } from "./ControleMudancaHorario.vue?vue&type=template&id=99411c5e&"
import script from "./ControleMudancaHorario.vue?vue&type=script&lang=js&"
export * from "./ControleMudancaHorario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports